import { Box, Stack, useDisclosure } from '@chakra-ui/react';
import { Button, Tooltip } from '@main/complykit';
import { useGetOrganizationQuery } from '@main/graphql/queries/GetOrganization.generated';
import { useUserData } from '@nhost/react';

import { ImportCsvDataType, ImportDataFromCsvModal } from './import-data-from-csv';

export const VendorsTab = ({ orgId }: { orgId: string }) => {
  const { data: organizationData } = useGetOrganizationQuery({ orgId });
  const organization = organizationData?.organizations_by_pk;

  const user = useUserData();
  const { isOpen: isImportOpen, onOpen: onOpenImport, onClose: onCloseImport } = useDisclosure();

  return (
    <Stack gap={8}>
      <Box alignSelf="end">
        <Tooltip
          content='Enable "Vendor module" for this organization'
          isDisabled={!!organization?.is_vendors_module_enabled}
        >
          <Button isDisabled={!organization?.is_vendors_module_enabled} onPress={onOpenImport}>
            Import from CSV
          </Button>
        </Tooltip>
      </Box>

      <ImportDataFromCsvModal
        key="import-vendors-modal"
        importType={ImportCsvDataType.VENDOR}
        orgId={orgId}
        email={user?.email}
        isModalOpen={isImportOpen}
        onModalClose={onCloseImport}
      />
    </Stack>
  );
};
